export class OrderCreateModel {
    public cartId: string;
    public imageId: number;
    public imageSize: number;
    public paymentId: string;
}
